let userCenter = [
  {
		path: '/login',
		name: 'login',
		component: ()=> import('@/views/userCenter/login'),
		meta: {
			name: '用户登录_知识产权',
      isNoNav: true
		}
	},
	{
		path: '/agreementDetail',
		name: 'agreementDetail',
		component: ()=> import('@/views/userCenter/agreementDetail'),
		meta: {
			name: '用户协议',
      isNoNav: true
		}
	},
]
export default userCenter